var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 8,
    viewBox: "0 0 73 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M0.5 3.18164C0.223858 3.18164 -2.41411e-08 3.4055 0 3.68164C2.41411e-08 3.95778 0.223858 4.18164 0.5 4.18164L0.5 3.68164L0.5 3.18164ZM72.8536 4.03519C73.0488 3.83993 73.0488 3.52334 72.8536 3.32808L69.6716 0.146101C69.4763 -0.0491615 69.1597 -0.0491615 68.9645 0.146101C68.7692 0.341363 68.7692 0.657945 68.9645 0.853208L71.7929 3.68163L68.9645 6.51006C68.7692 6.70532 68.7692 7.02191 68.9645 7.21717C69.1597 7.41243 69.4763 7.41243 69.6716 7.21717L72.8536 4.03519ZM0.5 3.68164L0.5 4.18164L72.5 4.18163L72.5 3.68163L72.5 3.18163L0.5 3.18164L0.5 3.68164Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.95c870771428ed221f0343019c686e2c.svg";
export { ForwardRef as ReactComponent };